/**
 * Lädt den Quelldatensatz eines Dialogs beim Öffnen — Port des `Fetch()`-Aufrufs aus
 * `Show()` (`IwmDialogContainerDuplizieren`, `IwmDialogBestellpositionAufteilen`).
 *
 * `load` muss stabil sein (`useCallback`), sonst wird bei jedem Rendern neu geladen.
 */

import { useEffect, useState } from 'react';

export function useDialogSource<T>(open: boolean, load: () => Promise<T>): T | null {
  const [source, setSource] = useState<T | null>(null);

  useEffect(() => {
    if (!open) {
      setSource(null);
      return;
    }
    let active = true;
    load()
      .then((value) => {
        if (active) setSource(value);
      })
      // Ohne Quelldatensatz zeigen die Dialoge ihren Hinweis „Bitte wählen Sie … aus".
      .catch(() => {
        if (active) setSource(null);
      });
    return () => {
      active = false;
    };
  }, [load, open]);

  return source;
}
